import React from "react";

const RedPoint = () => {
    return (
        <div
            style={{
                display: "inline-block",
                backgroundColor: "red",
                height: "6px",
                width: "6px",
                borderRadius: "50%",
                marginRight: "6px",
                marginBottom: "2px",
            }}
        ></div>
    );
};

export default RedPoint;



// WEBPACK FOOTER //
// ./src/scenes/reportes/components/RedPoint.js